/* Static pick-lists for searchable widget dropdowns.
 *
 * Why static, not fetched: these lists are stable for months / years (top
 * cities, top crypto coins, top stocks change extremely rarely) and keeping
 * them client-side means the widget configurator is fast even on poor
 * networks. Each entry includes the human label users search by AND the
 * canonical API id we send to the embed script.
 */

// Top ~200 cities worldwide — capitals + major metros across every continent.
// Latitude/longitude here is only used as a fallback for the legacy
// embed signature; the city name itself is what the dropdown stores.
export const CITY_OPTIONS = [
  { id: "New York", country: "US", label: "New York, United States", lat: 40.7128, lon: -74.006 },
  { id: "Los Angeles", country: "US", label: "Los Angeles, United States", lat: 34.0522, lon: -118.2437 },
  { id: "Chicago", country: "US", label: "Chicago, United States", lat: 41.8781, lon: -87.6298 },
  { id: "Houston", country: "US", label: "Houston, United States", lat: 29.7604, lon: -95.3698 },
  { id: "Phoenix", country: "US", label: "Phoenix, United States", lat: 33.4484, lon: -112.074 },
  { id: "Philadelphia", country: "US", label: "Philadelphia, United States", lat: 39.9526, lon: -75.1652 },
  { id: "San Antonio", country: "US", label: "San Antonio, United States", lat: 29.4241, lon: -98.4936 },
  { id: "San Diego", country: "US", label: "San Diego, United States", lat: 32.7157, lon: -117.1611 },
  { id: "Dallas", country: "US", label: "Dallas, United States", lat: 32.7767, lon: -96.797 },
  { id: "San Jose", country: "US", label: "San Jose, United States", lat: 37.3382, lon: -121.8863 },
  { id: "San Francisco", country: "US", label: "San Francisco, United States", lat: 37.7749, lon: -122.4194 },
  { id: "Austin", country: "US", label: "Austin, United States", lat: 30.2672, lon: -97.7431 },
  { id: "Seattle", country: "US", label: "Seattle, United States", lat: 47.6062, lon: -122.3321 },
  { id: "Denver", country: "US", label: "Denver, United States", lat: 39.7392, lon: -104.9903 },
  { id: "Boston", country: "US", label: "Boston, United States", lat: 42.3601, lon: -71.0589 },
  { id: "Miami", country: "US", label: "Miami, United States", lat: 25.7617, lon: -80.1918 },
  { id: "Atlanta", country: "US", label: "Atlanta, United States", lat: 33.749, lon: -84.388 },
  { id: "Las Vegas", country: "US", label: "Las Vegas, United States", lat: 36.1699, lon: -115.1398 },
  { id: "Washington", country: "US", label: "Washington, D.C., United States", lat: 38.9072, lon: -77.0369 },
  { id: "Toronto", country: "CA", label: "Toronto, Canada", lat: 43.6532, lon: -79.3832 },
  { id: "Montreal", country: "CA", label: "Montreal, Canada", lat: 45.5017, lon: -73.5673 },
  { id: "Vancouver", country: "CA", label: "Vancouver, Canada", lat: 49.2827, lon: -123.1207 },
  { id: "Calgary", country: "CA", label: "Calgary, Canada", lat: 51.0447, lon: -114.0719 },
  { id: "Mexico City", country: "MX", label: "Mexico City, Mexico", lat: 19.4326, lon: -99.1332 },
  { id: "Guadalajara", country: "MX", label: "Guadalajara, Mexico", lat: 20.6597, lon: -103.3496 },
  { id: "Sao Paulo", country: "BR", label: "São Paulo, Brazil", lat: -23.5505, lon: -46.6333 },
  { id: "Rio de Janeiro", country: "BR", label: "Rio de Janeiro, Brazil", lat: -22.9068, lon: -43.1729 },
  { id: "Brasilia", country: "BR", label: "Brasília, Brazil", lat: -15.8267, lon: -47.9218 },
  { id: "Buenos Aires", country: "AR", label: "Buenos Aires, Argentina", lat: -34.6037, lon: -58.3816 },
  { id: "Santiago", country: "CL", label: "Santiago, Chile", lat: -33.4489, lon: -70.6693 },
  { id: "Lima", country: "PE", label: "Lima, Peru", lat: -12.0464, lon: -77.0428 },
  { id: "Bogota", country: "CO", label: "Bogotá, Colombia", lat: 4.711, lon: -74.0721 },
  { id: "Caracas", country: "VE", label: "Caracas, Venezuela", lat: 10.4806, lon: -66.9036 },
  { id: "London", country: "GB", label: "London, United Kingdom", lat: 51.5074, lon: -0.1278 },
  { id: "Manchester", country: "GB", label: "Manchester, United Kingdom", lat: 53.4808, lon: -2.2426 },
  { id: "Birmingham", country: "GB", label: "Birmingham, United Kingdom", lat: 52.4862, lon: -1.8904 },
  { id: "Edinburgh", country: "GB", label: "Edinburgh, United Kingdom", lat: 55.9533, lon: -3.1883 },
  { id: "Dublin", country: "IE", label: "Dublin, Ireland", lat: 53.3498, lon: -6.2603 },
  { id: "Paris", country: "FR", label: "Paris, France", lat: 48.8566, lon: 2.3522 },
  { id: "Marseille", country: "FR", label: "Marseille, France", lat: 43.2965, lon: 5.3698 },
  { id: "Lyon", country: "FR", label: "Lyon, France", lat: 45.764, lon: 4.8357 },
  { id: "Madrid", country: "ES", label: "Madrid, Spain", lat: 40.4168, lon: -3.7038 },
  { id: "Barcelona", country: "ES", label: "Barcelona, Spain", lat: 41.3851, lon: 2.1734 },
  { id: "Valencia", country: "ES", label: "Valencia, Spain", lat: 39.4699, lon: -0.3763 },
  { id: "Lisbon", country: "PT", label: "Lisbon, Portugal", lat: 38.7223, lon: -9.1393 },
  { id: "Porto", country: "PT", label: "Porto, Portugal", lat: 41.1579, lon: -8.6291 },
  { id: "Rome", country: "IT", label: "Rome, Italy", lat: 41.9028, lon: 12.4964 },
  { id: "Milan", country: "IT", label: "Milan, Italy", lat: 45.4642, lon: 9.19 },
  { id: "Naples", country: "IT", label: "Naples, Italy", lat: 40.8518, lon: 14.2681 },
  { id: "Berlin", country: "DE", label: "Berlin, Germany", lat: 52.52, lon: 13.405 },
  { id: "Munich", country: "DE", label: "Munich, Germany", lat: 48.1351, lon: 11.582 },
  { id: "Hamburg", country: "DE", label: "Hamburg, Germany", lat: 53.5511, lon: 9.9937 },
  { id: "Frankfurt", country: "DE", label: "Frankfurt, Germany", lat: 50.1109, lon: 8.6821 },
  { id: "Cologne", country: "DE", label: "Cologne, Germany", lat: 50.9375, lon: 6.9603 },
  { id: "Amsterdam", country: "NL", label: "Amsterdam, Netherlands", lat: 52.3676, lon: 4.9041 },
  { id: "Rotterdam", country: "NL", label: "Rotterdam, Netherlands", lat: 51.9244, lon: 4.4777 },
  { id: "Brussels", country: "BE", label: "Brussels, Belgium", lat: 50.8503, lon: 4.3517 },
  { id: "Zurich", country: "CH", label: "Zurich, Switzerland", lat: 47.3769, lon: 8.5417 },
  { id: "Geneva", country: "CH", label: "Geneva, Switzerland", lat: 46.2044, lon: 6.1432 },
  { id: "Vienna", country: "AT", label: "Vienna, Austria", lat: 48.2082, lon: 16.3738 },
  { id: "Stockholm", country: "SE", label: "Stockholm, Sweden", lat: 59.3293, lon: 18.0686 },
  { id: "Oslo", country: "NO", label: "Oslo, Norway", lat: 59.9139, lon: 10.7522 },
  { id: "Copenhagen", country: "DK", label: "Copenhagen, Denmark", lat: 55.6761, lon: 12.5683 },
  { id: "Helsinki", country: "FI", label: "Helsinki, Finland", lat: 60.1699, lon: 24.9384 },
  { id: "Reykjavik", country: "IS", label: "Reykjavik, Iceland", lat: 64.1466, lon: -21.9426 },
  { id: "Warsaw", country: "PL", label: "Warsaw, Poland", lat: 52.2297, lon: 21.0122 },
  { id: "Krakow", country: "PL", label: "Kraków, Poland", lat: 50.0647, lon: 19.945 },
  { id: "Prague", country: "CZ", label: "Prague, Czechia", lat: 50.0755, lon: 14.4378 },
  { id: "Budapest", country: "HU", label: "Budapest, Hungary", lat: 47.4979, lon: 19.0402 },
  { id: "Athens", country: "GR", label: "Athens, Greece", lat: 37.9838, lon: 23.7275 },
  { id: "Istanbul", country: "TR", label: "Istanbul, Turkey", lat: 41.0082, lon: 28.9784 },
  { id: "Ankara", country: "TR", label: "Ankara, Turkey", lat: 39.9334, lon: 32.8597 },
  { id: "Moscow", country: "RU", label: "Moscow, Russia", lat: 55.7558, lon: 37.6173 },
  { id: "Saint Petersburg", country: "RU", label: "Saint Petersburg, Russia", lat: 59.9311, lon: 30.3609 },
  { id: "Kyiv", country: "UA", label: "Kyiv, Ukraine", lat: 50.4501, lon: 30.5234 },
  { id: "Cairo", country: "EG", label: "Cairo, Egypt", lat: 30.0444, lon: 31.2357 },
  { id: "Alexandria", country: "EG", label: "Alexandria, Egypt", lat: 31.2001, lon: 29.9187 },
  { id: "Lagos", country: "NG", label: "Lagos, Nigeria", lat: 6.5244, lon: 3.3792 },
  { id: "Abuja", country: "NG", label: "Abuja, Nigeria", lat: 9.0765, lon: 7.3986 },
  { id: "Nairobi", country: "KE", label: "Nairobi, Kenya", lat: -1.2921, lon: 36.8219 },
  { id: "Addis Ababa", country: "ET", label: "Addis Ababa, Ethiopia", lat: 9.03, lon: 38.7469 },
  { id: "Johannesburg", country: "ZA", label: "Johannesburg, South Africa", lat: -26.2041, lon: 28.0473 },
  { id: "Cape Town", country: "ZA", label: "Cape Town, South Africa", lat: -33.9249, lon: 18.4241 },
  { id: "Casablanca", country: "MA", label: "Casablanca, Morocco", lat: 33.5731, lon: -7.5898 },
  { id: "Algiers", country: "DZ", label: "Algiers, Algeria", lat: 36.7538, lon: 3.0588 },
  { id: "Tunis", country: "TN", label: "Tunis, Tunisia", lat: 36.8065, lon: 10.1815 },
  { id: "Dubai", country: "AE", label: "Dubai, UAE", lat: 25.2048, lon: 55.2708 },
  { id: "Abu Dhabi", country: "AE", label: "Abu Dhabi, UAE", lat: 24.4539, lon: 54.3773 },
  { id: "Doha", country: "QA", label: "Doha, Qatar", lat: 25.2854, lon: 51.531 },
  { id: "Riyadh", country: "SA", label: "Riyadh, Saudi Arabia", lat: 24.7136, lon: 46.6753 },
  { id: "Jeddah", country: "SA", label: "Jeddah, Saudi Arabia", lat: 21.4858, lon: 39.1925 },
  { id: "Tehran", country: "IR", label: "Tehran, Iran", lat: 35.6892, lon: 51.389 },
  { id: "Baghdad", country: "IQ", label: "Baghdad, Iraq", lat: 33.3152, lon: 44.3661 },
  { id: "Jerusalem", country: "IL", label: "Jerusalem, Israel", lat: 31.7683, lon: 35.2137 },
  { id: "Tel Aviv", country: "IL", label: "Tel Aviv, Israel", lat: 32.0853, lon: 34.7818 },
  { id: "Karachi", country: "PK", label: "Karachi, Pakistan", lat: 24.8607, lon: 67.0011 },
  { id: "Lahore", country: "PK", label: "Lahore, Pakistan", lat: 31.5204, lon: 74.3587 },
  { id: "Islamabad", country: "PK", label: "Islamabad, Pakistan", lat: 33.6844, lon: 73.0479 },
  { id: "Mumbai", country: "IN", label: "Mumbai, India", lat: 19.076, lon: 72.8777 },
  { id: "Delhi", country: "IN", label: "Delhi, India", lat: 28.7041, lon: 77.1025 },
  { id: "Bengaluru", country: "IN", label: "Bengaluru, India", lat: 12.9716, lon: 77.5946 },
  { id: "Hyderabad", country: "IN", label: "Hyderabad, India", lat: 17.385, lon: 78.4867 },
  { id: "Chennai", country: "IN", label: "Chennai, India", lat: 13.0827, lon: 80.2707 },
  { id: "Kolkata", country: "IN", label: "Kolkata, India", lat: 22.5726, lon: 88.3639 },
  { id: "Pune", country: "IN", label: "Pune, India", lat: 18.5204, lon: 73.8567 },
  { id: "Ahmedabad", country: "IN", label: "Ahmedabad, India", lat: 23.0225, lon: 72.5714 },
  { id: "Jaipur", country: "IN", label: "Jaipur, India", lat: 26.9124, lon: 75.7873 },
  { id: "Dhaka", country: "BD", label: "Dhaka, Bangladesh", lat: 23.8103, lon: 90.4125 },
  { id: "Kathmandu", country: "NP", label: "Kathmandu, Nepal", lat: 27.7172, lon: 85.324 },
  { id: "Colombo", country: "LK", label: "Colombo, Sri Lanka", lat: 6.9271, lon: 79.8612 },
  { id: "Bangkok", country: "TH", label: "Bangkok, Thailand", lat: 13.7563, lon: 100.5018 },
  { id: "Hanoi", country: "VN", label: "Hanoi, Vietnam", lat: 21.0285, lon: 105.8542 },
  { id: "Ho Chi Minh City", country: "VN", label: "Ho Chi Minh City, Vietnam", lat: 10.8231, lon: 106.6297 },
  { id: "Jakarta", country: "ID", label: "Jakarta, Indonesia", lat: -6.2088, lon: 106.8456 },
  { id: "Surabaya", country: "ID", label: "Surabaya, Indonesia", lat: -7.2575, lon: 112.7521 },
  { id: "Kuala Lumpur", country: "MY", label: "Kuala Lumpur, Malaysia", lat: 3.139, lon: 101.6869 },
  { id: "Singapore", country: "SG", label: "Singapore", lat: 1.3521, lon: 103.8198 },
  { id: "Manila", country: "PH", label: "Manila, Philippines", lat: 14.5995, lon: 120.9842 },
  { id: "Beijing", country: "CN", label: "Beijing, China", lat: 39.9042, lon: 116.4074 },
  { id: "Shanghai", country: "CN", label: "Shanghai, China", lat: 31.2304, lon: 121.4737 },
  { id: "Guangzhou", country: "CN", label: "Guangzhou, China", lat: 23.1291, lon: 113.2644 },
  { id: "Shenzhen", country: "CN", label: "Shenzhen, China", lat: 22.5431, lon: 114.0579 },
  { id: "Hong Kong", country: "HK", label: "Hong Kong", lat: 22.3193, lon: 114.1694 },
  { id: "Taipei", country: "TW", label: "Taipei, Taiwan", lat: 25.033, lon: 121.5654 },
  { id: "Seoul", country: "KR", label: "Seoul, South Korea", lat: 37.5665, lon: 126.978 },
  { id: "Busan", country: "KR", label: "Busan, South Korea", lat: 35.1796, lon: 129.0756 },
  { id: "Tokyo", country: "JP", label: "Tokyo, Japan", lat: 35.6762, lon: 139.6503 },
  { id: "Osaka", country: "JP", label: "Osaka, Japan", lat: 34.6937, lon: 135.5023 },
  { id: "Kyoto", country: "JP", label: "Kyoto, Japan", lat: 35.0116, lon: 135.7681 },
  { id: "Sydney", country: "AU", label: "Sydney, Australia", lat: -33.8688, lon: 151.2093 },
  { id: "Melbourne", country: "AU", label: "Melbourne, Australia", lat: -37.8136, lon: 144.9631 },
  { id: "Brisbane", country: "AU", label: "Brisbane, Australia", lat: -27.4698, lon: 153.0251 },
  { id: "Perth", country: "AU", label: "Perth, Australia", lat: -31.9505, lon: 115.8605 },
  { id: "Auckland", country: "NZ", label: "Auckland, New Zealand", lat: -36.8485, lon: 174.7633 },
  { id: "Wellington", country: "NZ", label: "Wellington, New Zealand", lat: -41.2865, lon: 174.7762 },
];

// Top 100 crypto coins by market cap — CoinGecko id + display symbol.
// Curated list; refresh annually as the top-100 shifts.
export const CRYPTO_OPTIONS = [
  { id: "bitcoin", label: "Bitcoin (BTC)" },
  { id: "ethereum", label: "Ethereum (ETH)" },
  { id: "tether", label: "Tether (USDT)" },
  { id: "binancecoin", label: "BNB (BNB)" },
  { id: "solana", label: "Solana (SOL)" },
  { id: "ripple", label: "XRP (XRP)" },
  { id: "usd-coin", label: "USD Coin (USDC)" },
  { id: "staked-ether", label: "Lido Staked Ether (stETH)" },
  { id: "cardano", label: "Cardano (ADA)" },
  { id: "dogecoin", label: "Dogecoin (DOGE)" },
  { id: "tron", label: "TRON (TRX)" },
  { id: "shiba-inu", label: "Shiba Inu (SHIB)" },
  { id: "avalanche-2", label: "Avalanche (AVAX)" },
  { id: "wrapped-bitcoin", label: "Wrapped Bitcoin (WBTC)" },
  { id: "chainlink", label: "Chainlink (LINK)" },
  { id: "polkadot", label: "Polkadot (DOT)" },
  { id: "bitcoin-cash", label: "Bitcoin Cash (BCH)" },
  { id: "matic-network", label: "Polygon (MATIC)" },
  { id: "near", label: "NEAR Protocol (NEAR)" },
  { id: "litecoin", label: "Litecoin (LTC)" },
  { id: "uniswap", label: "Uniswap (UNI)" },
  { id: "internet-computer", label: "Internet Computer (ICP)" },
  { id: "leo-token", label: "LEO Token (LEO)" },
  { id: "dai", label: "Dai (DAI)" },
  { id: "ethereum-classic", label: "Ethereum Classic (ETC)" },
  { id: "aptos", label: "Aptos (APT)" },
  { id: "stellar", label: "Stellar (XLM)" },
  { id: "cosmos", label: "Cosmos (ATOM)" },
  { id: "monero", label: "Monero (XMR)" },
  { id: "okb", label: "OKB (OKB)" },
  { id: "render-token", label: "Render (RNDR)" },
  { id: "filecoin", label: "Filecoin (FIL)" },
  { id: "hedera-hashgraph", label: "Hedera (HBAR)" },
  { id: "crypto-com-chain", label: "Cronos (CRO)" },
  { id: "vechain", label: "VeChain (VET)" },
  { id: "arbitrum", label: "Arbitrum (ARB)" },
  { id: "mantle", label: "Mantle (MNT)" },
  { id: "true-usd", label: "TrueUSD (TUSD)" },
  { id: "immutable-x", label: "Immutable (IMX)" },
  { id: "kaspa", label: "Kaspa (KAS)" },
  { id: "the-graph", label: "The Graph (GRT)" },
  { id: "stacks", label: "Stacks (STX)" },
  { id: "injective-protocol", label: "Injective (INJ)" },
  { id: "lido-dao", label: "Lido DAO (LDO)" },
  { id: "rocket-pool-eth", label: "Rocket Pool ETH (rETH)" },
  { id: "optimism", label: "Optimism (OP)" },
  { id: "maker", label: "Maker (MKR)" },
  { id: "bittensor", label: "Bittensor (TAO)" },
  { id: "celestia", label: "Celestia (TIA)" },
  { id: "first-digital-usd", label: "First Digital USD (FDUSD)" },
  { id: "fantom", label: "Fantom (FTM)" },
  { id: "thorchain", label: "THORChain (RUNE)" },
  { id: "pepe", label: "Pepe (PEPE)" },
  { id: "algorand", label: "Algorand (ALGO)" },
  { id: "sei-network", label: "Sei (SEI)" },
  { id: "quant-network", label: "Quant (QNT)" },
  { id: "tezos", label: "Tezos (XTZ)" },
  { id: "aave", label: "Aave (AAVE)" },
  { id: "axie-infinity", label: "Axie Infinity (AXS)" },
  { id: "flow", label: "Flow (FLOW)" },
  { id: "the-sandbox", label: "The Sandbox (SAND)" },
  { id: "theta-token", label: "Theta Network (THETA)" },
  { id: "decentraland", label: "Decentraland (MANA)" },
  { id: "kucoin-shares", label: "KuCoin (KCS)" },
  { id: "neo", label: "NEO (NEO)" },
  { id: "elrond-erd-2", label: "MultiversX (EGLD)" },
  { id: "chiliz", label: "Chiliz (CHZ)" },
  { id: "eos", label: "EOS (EOS)" },
  { id: "iota", label: "IOTA (MIOTA)" },
  { id: "klay-token", label: "Klaytn (KLAY)" },
  { id: "gala", label: "GALA (GALA)" },
  { id: "mina-protocol", label: "Mina (MINA)" },
  { id: "frax", label: "Frax (FRAX)" },
  { id: "zcash", label: "Zcash (ZEC)" },
  { id: "ftx-token", label: "FTX Token (FTT)" },
  { id: "blockstack", label: "Stacks (STX)" },
  { id: "dash", label: "Dash (DASH)" },
  { id: "kava", label: "Kava (KAVA)" },
  { id: "compound-governance-token", label: "Compound (COMP)" },
  { id: "1inch", label: "1inch Network (1INCH)" },
  { id: "synthetix-network-token", label: "Synthetix (SNX)" },
  { id: "basic-attention-token", label: "Basic Attention Token (BAT)" },
];

// Top stocks by daily trading volume + popularity. Symbol matches Alpha Vantage.
export const STOCK_OPTIONS = [
  { id: "AAPL", label: "Apple (AAPL)" },
  { id: "MSFT", label: "Microsoft (MSFT)" },
  { id: "GOOGL", label: "Alphabet Class A (GOOGL)" },
  { id: "GOOG", label: "Alphabet Class C (GOOG)" },
  { id: "AMZN", label: "Amazon (AMZN)" },
  { id: "NVDA", label: "NVIDIA (NVDA)" },
  { id: "META", label: "Meta Platforms (META)" },
  { id: "TSLA", label: "Tesla (TSLA)" },
  { id: "BRK.B", label: "Berkshire Hathaway B (BRK.B)" },
  { id: "JPM", label: "JPMorgan Chase (JPM)" },
  { id: "JNJ", label: "Johnson & Johnson (JNJ)" },
  { id: "V", label: "Visa (V)" },
  { id: "MA", label: "Mastercard (MA)" },
  { id: "PG", label: "Procter & Gamble (PG)" },
  { id: "UNH", label: "UnitedHealth (UNH)" },
  { id: "HD", label: "Home Depot (HD)" },
  { id: "BAC", label: "Bank of America (BAC)" },
  { id: "WMT", label: "Walmart (WMT)" },
  { id: "DIS", label: "Walt Disney (DIS)" },
  { id: "NFLX", label: "Netflix (NFLX)" },
  { id: "ADBE", label: "Adobe (ADBE)" },
  { id: "CRM", label: "Salesforce (CRM)" },
  { id: "ORCL", label: "Oracle (ORCL)" },
  { id: "INTC", label: "Intel (INTC)" },
  { id: "AMD", label: "AMD (AMD)" },
  { id: "PYPL", label: "PayPal (PYPL)" },
  { id: "SHOP", label: "Shopify (SHOP)" },
  { id: "UBER", label: "Uber (UBER)" },
  { id: "ABNB", label: "Airbnb (ABNB)" },
  { id: "SPOT", label: "Spotify (SPOT)" },
  { id: "SQ", label: "Block / Square (SQ)" },
  { id: "COIN", label: "Coinbase (COIN)" },
  { id: "PLTR", label: "Palantir (PLTR)" },
  { id: "SNOW", label: "Snowflake (SNOW)" },
  { id: "ZM", label: "Zoom (ZM)" },
  { id: "ROKU", label: "Roku (ROKU)" },
  { id: "PINS", label: "Pinterest (PINS)" },
  { id: "SNAP", label: "Snap (SNAP)" },
  { id: "TWLO", label: "Twilio (TWLO)" },
  { id: "DOCU", label: "DocuSign (DOCU)" },
  { id: "MRNA", label: "Moderna (MRNA)" },
  { id: "PFE", label: "Pfizer (PFE)" },
  { id: "ABBV", label: "AbbVie (ABBV)" },
  { id: "KO", label: "Coca-Cola (KO)" },
  { id: "PEP", label: "PepsiCo (PEP)" },
  { id: "MCD", label: "McDonald's (MCD)" },
  { id: "SBUX", label: "Starbucks (SBUX)" },
  { id: "NKE", label: "Nike (NKE)" },
  { id: "XOM", label: "ExxonMobil (XOM)" },
  { id: "CVX", label: "Chevron (CVX)" },
  { id: "BA", label: "Boeing (BA)" },
  { id: "GE", label: "GE Aerospace (GE)" },
  { id: "F", label: "Ford (F)" },
  { id: "GM", label: "General Motors (GM)" },
  { id: "LCID", label: "Lucid (LCID)" },
  { id: "RIVN", label: "Rivian (RIVN)" },
  { id: "T", label: "AT&T (T)" },
  { id: "VZ", label: "Verizon (VZ)" },
  { id: "QCOM", label: "Qualcomm (QCOM)" },
  { id: "TXN", label: "Texas Instruments (TXN)" },
  { id: "IBM", label: "IBM (IBM)" },
  { id: "CSCO", label: "Cisco (CSCO)" },
  { id: "MU", label: "Micron (MU)" },
  { id: "AVGO", label: "Broadcom (AVGO)" },
  { id: "TSM", label: "Taiwan Semiconductor (TSM)" },
  { id: "SAP", label: "SAP (SAP)" },
  { id: "ASML", label: "ASML (ASML)" },
  { id: "BABA", label: "Alibaba (BABA)" },
  { id: "TCEHY", label: "Tencent (TCEHY)" },
  { id: "JD", label: "JD.com (JD)" },
  { id: "PDD", label: "PDD Holdings (PDD)" },
  { id: "SPY", label: "S&P 500 ETF (SPY)" },
  { id: "QQQ", label: "Nasdaq-100 ETF (QQQ)" },
  { id: "VTI", label: "Total Market ETF (VTI)" },
  { id: "VOO", label: "S&P 500 (VOO)" },
  { id: "ARKK", label: "ARK Innovation (ARKK)" },
];
